export enum TipoFiltro {
  PASTILLA,
  DESPLEGABLE_MULTI,
  FECHA,
  TEXTO,
  DESPLEGABLE_SINGLE
}
